<template>
  <div class="container">
    <heard :title="'语言评估'" ref="heard" />
    <div class="content">
      <div class="content-inner">
        <div class="markdown-body" v-html="renderedHtml"></div>
      </div>
      <div class="table-wrapper">
        <div v-html="currentTableHtml"></div>
      </div>
    </div>
    <div class="tabs-container">
      <el-tabs v-model="activeTab" type="card" class="table-tabs">
        <el-tab-pane
          v-for="(tableData, index) in tables"
          :key="index"
          :label="tableData.title"
          :name="String(index)"
        />
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { marked } from "marked";
import heard from "../components/heard.vue";

export default {
  name: "TemplateData",
  data() {
    return {
      renderedHtml: "",
      activeTab: "0",
      tables: [],
    };
  },
  computed: {
    currentTableHtml() {
      const index = parseInt(this.activeTab);
      return this.tables[index]?.html || "";
    },
  },
  mounted() {
    this.fetchMarkdown();
  },
  methods: {
    async fetchMarkdown() {
      try {
        const response = await fetch("/templateData.md");
        const markdown = await response.text();
        this.parseAndRender(markdown);
      } catch (error) {
        this.renderedHtml = "<p>加载文档失败</p>";
      }
    },
    parseAndRender(markdown) {
      const tokens = marked.lexer(markdown);
      const tables = [];
      const nonTableTokens = [];
      let currentTable = null;
      let currentTitle = "";

      tokens.forEach((token) => {
        if (token.type === "heading" && token.depth === 2) {
          if (currentTable) {
            tables.push({ title: currentTitle, tokens: currentTable });
            currentTable = null;
          }
          currentTitle = this.stripTags(token.text);
        } else if (token.type === "table") {
          if (!currentTable) {
            currentTable = [];
          }
          currentTable.push(token);
        } else if (token.type === "table_cell" || token.type === "table_row") {
          if (currentTable) {
            currentTable.push(token);
          } else {
            nonTableTokens.push(token);
          }
        } else {
          if (currentTable && token.type !== "space") {
            tables.push({ title: currentTitle, tokens: currentTable });
            currentTable = null;
          }
          nonTableTokens.push(token);
        }
      });

      if (currentTable) {
        tables.push({ title: currentTitle, tokens: currentTable });
      }

      const renderer = new marked.Renderer();
      this.renderedHtml = marked.parser(nonTableTokens, { renderer });

      this.tables = tables.map((table) => ({
        title: table.title,
        html: marked.parser(table.tokens, { renderer }),
      }));
    },
    stripTags(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || "";
    },
  },
  components: {
    heard,
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 30px 50px;
  background: #97bd97;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
}

.content-inner {
  max-width: 900px;
  margin: 0 auto 30px;
}

.markdown-body {
  margin: 0 auto;
  line-height: 1.8;
  font-size: 16px;
  color: #333;

  h1 {
    font-size: 28px;
    border-bottom: 2px solid #97bd97;
    padding-bottom: 10px;
    margin: 30px 0 20px;
  }

  h2 {
    font-size: 22px;
    margin: 30px 0 15px;
    color: #568156;
    padding-left: 10px;
    border-left: 4px solid #97bd97;
  }

  h3 {
    font-size: 18px;
    margin: 20px 0 10px;
  }

  p {
    margin: 10px 0;
  }

  ul, ol {
    padding-left: 24px;
    margin: 10px 0;
  }

  li {
    margin: 5px 0;
  }

  code {
    background: #f4f4f4;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 14px;
  }

  pre {
    background: #f4f4f4;
    padding: 15px;
    border-radius: 5px;
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
    }
  }

  blockquote {
    border-left: 4px solid #97bd97;
    padding-left: 16px;
    color: #666;
    margin: 15px 0;
  }
}

.tabs-container {
  border-top: 1px solid #e8e8e8;
  background: #fff;
  padding: 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.table-tabs {
  :deep(.el-tabs__header) {
    margin-bottom: 20px;
  }

  :deep(.el-tabs__item) {
    padding: 0 20px;
    font-size: 20px !important;
    height: 50px !important;
    line-height: 50px !important;
  }

  :deep(.el-tab-pane) {
    padding: 0;
  }

  :deep(.el-tabs__header .el-tabs__active-bar) {
    top: 0 !important;
    bottom: auto !important;
  }
}
.table-wrapper {
  overflow-x: auto;
  max-height: 850px;
  overflow-y: auto;
  width: 100%;

  :deep(table) {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #000 !important;
  }

  :deep(th),
  :deep(td) {
    border: 1px solid #000 !important;
    padding: 8px 12px;
    text-align: left;
    font-size: 20px;
  }

  :deep(th) {
    background: #97bd97;
    color: #0c0c0c;
    font-weight: bold;
    position: sticky;
    font-size: 20px;
    top: 0;
  }

  :deep(tr:nth-child(even)) {
    background: #97bd97;
  }
   :deep(.el-tabs__active-bar) {
  top: 0 !important;
  bottom: auto !important;
}

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
}
</style>
